import { useEffect, useState, Component } from "react";
import "../../../scss/backoffice.scss";
import { Sidemenu } from "../Sidemenu";
import { Topbar } from "../Topbar";
import { Footer } from "../Footers";
import { Container, Row, Col, Button, Modal } from "react-bootstrap";
import { FileUploader } from "react-drag-drop-files";
import {
  GetUniformSurveysItemList,
  UniformDeleteByEmployeeID,
  UploadExcelMasterFile,
} from "../../../services/ApiUniformSurveyBackoffice";
import {
  UniformLatestType,
  RequestDetailModal,
  ImportResult,
} from "../../../model/datatype";
import Moment from "moment";
import ReactPaginate from "react-paginate";
// import * as FileSaver from "file-saver";
const FileSaver = require("file-saver");
import * as Excel from "exceljs";
import { InputGroup, Form, Alert, Table } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import moment from "moment-timezone";
import ProgressBar from "react-bootstrap/ProgressBar";
import ReactTooltip from "react-tooltip";
import { useTranslation } from "react-i18next";
import { CreateUniformSueryForUsers } from "../../../modal/CreateUniformSueryForUsers";
import { idText } from "typescript";
import Swal from "sweetalert2";
const timezoneStr =
  Intl.DateTimeFormat().resolvedOptions().timeZone || "FallbackTimeZone";
const fileTypes = ["xlsx"];
let importExts: any = [];
let importFails: any = [];
let arrimportSuccess: any = [];

export const UniformSummay = (props: any) => {
  const [templateError, setTemplateError] = useState("");
  const [pageLoder, setPageLoder] = useState(false);
  const [resultActive, setResultActive] = useState(false);
  const [importInfo, setImportInfo] = useState<ImportResult | null>(null);
  const [uploading, setUploading] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const [uploadModalShow, setUploadModalShow] = useState(false);
  const [checked, setChecked] = useState(false);
  const [file, setFile] = useState(null);
  const [search, setSearch] = useState("");
  const current_year = new Date().getFullYear();
  const current_month = new Date().getMonth() + 1;
  const [loder, setLoader] = useState(true);
  const [filter, setFilter] = useState({
    year: current_year,
    status: 10,
    employeeId: "",
    limit: 10,
    offset: 0,
  });
  const [requestLists, setRequestLists] = useState<[RequestDetailModal] | null>(
    null
  );
  const [requestListsAll, setRequestListsAll] = useState<
    [RequestDetailModal] | null
  >(null);
  const [requestItem, setRequestItem] = useState<UniformLatestType | null>(
    null
  );
  const years = [];
  const [pagination, setPagination] = useState({
    totalPage: 0,
    currentPage: 1,
    totalCount: 0,
  });
  const [bathFile, setBathFile] = useState(-1);
  const [fileImport, setFileImport] = useState(null);
  const [limit, setLimit] = useState(100);
  const [importOffset, setImportOffset] = useState(0);
  const [offset, setOffset] = useState(0);
  const [offsetAll, setOffsetAll] = useState(10);
  const [totalImport, setTotalImport] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [importSuccess, setImportSuccess] = useState(0);
  const [importStatus, setImportStatus] = useState(false);
  const [progress, setProgress] = useState(0);
  const [pagesSelected, setPagesSelected] = useState(0);

  const [employeeID, setEmployeeID] = useState();

  const { t } = useTranslation();
  for (let startY = current_year; startY > current_year - 4; startY--) {
    years.push(startY);
  }
  const [uniformImage, setUniformImage] = useState("");
  const [formCreateModalShow, setFormCreateModalShow] = useState(false);
  const [alertOptions, setAlertOptions] = useState<any>({
    title: "Warning!",
    text: "Are you sure you want delete?",
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Yes",
  });
  const setInputValue = (e: any) => {
    const { name, value } = e.target;
    //setFilter((oldValues: any) => ({ ...oldValues, ['offset']: 0 }));
    //setFilter((oldValues: any) => ({ ...oldValues, [name]: value }));
    if (name !== "search") {
      setFilter((oldValues: any) => ({ ...oldValues, ["offset"]: 0 }));
      setFilter((oldValues: any) => ({ ...oldValues, [name]: value }));
      setRequestLists(null);
      setOffset(0);
    } else {
      setSearch(value);
    }
  };
  const onEnterSearch = (e: any) => {
    const { name, value } = e.target;
    if (name === "search" && e.key === "Enter") {
      setRequestLists(null);
      setFilter((oldValues: any) => ({ ...oldValues, ["employeeId"]: value }));
      setFilter((oldValues: any) => ({ ...oldValues, ["offset"]: 0 }));
    }
  };
  const onClickSearch = (e: any) => {
    setRequestLists(null);
    setFilter((oldValues: any) => ({ ...oldValues, ["employeeId"]: search }));
  };

  const helpModalClose = () => {
    setUploadModalShow(false);
    setModalShow(false);
    //console.log('close');
    setImportInfo(null);
    setRequestLists(null);
    setTemplateError("");
  };

  const handleChange = (file: any) => {
    setUploading(true);
    setFileImport(file);
    setBathFile(1);
  };
  const handleClickImport = () => {
    importExts = [];
    importFails = [];
    arrimportSuccess = [];
    setImportInfo(null);
    setImportStatus(false);
    setImportOffset(0);
    setTotalImport(1);
    setProgress(0);
    setUploadModalShow(true);
  };
  const handleExport = () => {
    // Export logic
  };
  const handlePageClick = (event: any) => {
    setRequestLists(null);
    const newOffset = (event.selected * filter.limit) % pagination.totalCount;
    setPagesSelected(event.selected);
    setOffset(newOffset);
    // console.log('newOffset=',newOffset)
    // setOffsetAll(newOffset)
    // console.log('offsetAll=',offsetAll);
    setFilter((oldValues: any) => ({ ...oldValues, ["offset"]: newOffset }));
  };
  const onView = (item: any) => {
    setRequestItem(item);
    setModalShow(true);
  };

  const onCreateSurvey = () => {
    setIsCreateForm(true);
    isCreateForm && setEmployeeID(undefined);
    setFormCreateModalShow(true);
  };

  const onCancelCreateSurvey = () => {
    setFormCreateModalShow(false);
    //  setRequestLists(null);
  };

  const onClearData = () => {
    setRequestLists(null);
  };

  const onDel = (ID: any, employeeID: any) => {
    Swal.fire(alertOptions).then((sr) => {
      sr.isConfirmed &&
        UniformDeleteByEmployeeID(ID).then((response) => {
          const getData: any = response;
          if (getData) {
            setRequestLists(null);
            Swal.fire("Summary Delete", "Successfuly", "info");
            Swal.update({
              icon: "success",
            });
            // toast.success('delete successfully.', {
            //   position: 'top-right',
            //   autoClose: 3000,
            //   hideProgressBar: false,
            //   closeOnClick: true,
            //   pauseOnHover: true,
            //   draggable: true,
            //   progress: undefined,
            // });
          }
        });
    });
    // if (window.confirm('Are you sure delete: empID(' + employeeID + ')')) {
    //   UniformDeleteByEmployeeID(ID)
    //     .then((response) => {
    //       const getData: any = response;
    //       console.log('getData=', getData);
    //       if (getData) {
    //         setRequestLists(null);
    //         toast.success('delete successfully.', {
    //           position: 'top-right',
    //           autoClose: 3000,
    //           hideProgressBar: false,
    //           closeOnClick: true,
    //           pauseOnHover: true,
    //           draggable: true,
    //           progress: undefined,
    //         });
    //       }
    //     })
    //     .catch((error: any) => {
    //       console.log('error=', error);
    //     });
    // }
  };

  const onEdit = (employeeID: any) => {
    //alert(employeeID);
    setIsCreateForm(false);
    setEmployeeID(employeeID);
    setFormCreateModalShow(true);
  };

  const arrGender: any = {
    Female: "หญิง",
    Male: "ผู้ชาย",
  };

  const checkShirtChange = (getItem: string, item?: any): string => {
    const resolved = getItem ||
      item?.uniformSurveyExtensions?.[0]?.shirtType ||
      (item?.changedType ? '(Changed)' : '');
    if (resolved === "Red Collar" || resolved === "Driver Shirt") {
      return "Grey Collar";
    }
    return resolved;
  };

  const exportToExcel = async () => {
    // alert('export');
    // return false;
    setPageLoder(true);
    // filter.year = 2024;
    //console.log('filter=',filter)
    //return false;
    const resultGet = await GetUniformSurveysItemList(filter, "no").then(
      (response: any) => {
        const getData: any = response;

        // ใช้ Map เพื่อเก็บเฉพาะรายการแรกของแต่ละ employeeId
        const uniqueTrans = Array.from(
          new Map(
            getData.trans.map((item: any) => [item.employeeId, item])
          ).values()
        );
        setRequestListsAll(getData.advanceSalaryRequests);
        setLoader(false);
        setPageLoder(false);

        return uniqueTrans;
      }
    );

    const workbook = new Excel.Workbook();
    workbook.creator = "AdvanceSalaryRequest";
    workbook.lastModifiedBy = "AdvanceSalaryRequestM";
    workbook.created = new Date(1985, 8, 30);
    workbook.modified = new Date();
    workbook.lastPrinted = new Date(2016, 9, 27);

    const worksheet = workbook.addWorksheet("UniformSummary", {
      views: [{ state: "frozen", ySplit: 1 }],
    });

    worksheet.properties.defaultRowHeight = 30;
    worksheet.properties.defaultColWidth = 30;
    const column: any = [
      {
        header: "Emp ID",
        width: 14,
        key: "employeeId",
        style: {
          alignment: {
            vertical: "middle",
            horizontal: "left",
            wrapText: false,
          },
        },
      },
      {
        header: "Emp ID (7 Digits)",
        width: 16,
        key: "employeeId7Digit",
        style: {
          alignment: {
            vertical: "middle",
            horizontal: "left",
            wrapText: false,
          },
        },
      },
      {
        header: "Gender",
        key: "gender",
        width: 14,
        style: {
          alignment: {
            vertical: "middle",
            horizontal: "left",
            wrapText: false,
          },
        },
      },
      {
        header: "Department Code",
        key: "departmentCode",
        width: 50,
        style: {
          alignment: {
            vertical: "middle",
            horizontal: "left",
            wrapText: false,
          },
        },
      },
      {
        header: "Department Name",
        key: "departmentName",
        width: 50,
        style: {
          alignment: {
            vertical: "middle",
            horizontal: "left",
            wrapText: false,
          },
        },
      },
      {
        header: "Employee Name",
        key: "employeeName",
        width: 50,
        style: {
          alignment: {
            vertical: "middle",
            horizontal: "left",
            wrapText: false,
          },
        },
      },
      {
        header: "Job Level",
        key: "jobLevel",
        width: 50,
        style: {
          alignment: {
            vertical: "middle",
            horizontal: "left",
            wrapText: false,
          },
        },
      },
      {
        header: "Changed Type",
        width: 30,
        key: "changedType",
        style: {
          alignment: { vertical: "middle", horizontal: "left", wrapText: true },
        },
      },
      {
        header: "Shirt Type",
        key: "shirtType",
        width: 30,
        style: {
          alignment: { vertical: "middle", horizontal: "left", wrapText: true },
        },
      },
      {
        header: "Shirt Qty",
        width: 20,
        key: "shirtQty",
        style: {
          alignment: {
            vertical: "middle",
            horizontal: "center",
            wrapText: false,
          },
        },
      },
      {
        header: "Shirt Gender",
        width: 20,
        key: "shirtGender",
        style: {
          alignment: {
            vertical: "middle",
            horizontal: "center",
            wrapText: false,
          },
        },
      },
      {
        header: "Shirt Size",
        width: 30,
        key: "shirtSize",
        style: {
          alignment: { vertical: "middle", horizontal: "left", wrapText: true },
        },
      },
      {
        header: "Shirt Description",
        width: 30,
        key: "shirtSizeDescription",
        style: {
          alignment: { vertical: "middle", horizontal: "left", wrapText: true },
        },
      },
      {
        header: "Pant Qty",
        width: 30,
        key: "pantQty",
        style: {
          alignment: {
            vertical: "middle",
            horizontal: "center",
            wrapText: true,
          },
        },
      },
      {
        header: "Pant Size",
        width: 30,
        key: "pantSize",
        style: {
          alignment: { vertical: "middle", horizontal: "left", wrapText: true },
        },
      },
      {
        header: "Pant Description",
        width: 30,
        key: "pantSizeDescription",
        style: {
          alignment: { vertical: "middle", horizontal: "left", wrapText: true },
        },
      },
      {
        header: "Pant Gender",
        width: 30,
        key: "pantGender",
        style: {
          alignment: { vertical: "middle", horizontal: "left", wrapText: true },
        },
      },
      {
        header: "Dress Qty",
        width: 30,
        key: "dressQty",
        style: {
          alignment: {
            vertical: "middle",
            horizontal: "center",
            wrapText: true,
          },
        },
      },
      {
        header: "Dress Size",
        width: 30,
        key: "dressSize",
        style: {
          alignment: { vertical: "middle", horizontal: "left", wrapText: true },
        },
      },
      {
        header: "Dress Description",
        width: 30,
        key: "dressSizeDescription",
        style: {
          alignment: { vertical: "middle", horizontal: "left", wrapText: true },
        },
      },
      {
        header: "Slipper Qty",
        width: 30,
        key: "slipperQty",
        style: {
          alignment: {
            vertical: "middle",
            horizontal: "center",
            wrapText: true,
          },
        },
      },
      {
        header: "Slipper Size",
        width: 30,
        key: "slipperSize",
        style: {
          alignment: { vertical: "middle", horizontal: "left", wrapText: true },
        },
      },
      {
        header: "Slipper Description",
        width: 30,
        key: "slipperSizeDescription",
        style: {
          alignment: { vertical: "middle", horizontal: "left", wrapText: true },
        },
      },
      {
        header: "Bra Qty",
        width: 30,
        key: "braQty",
        style: {
          alignment: {
            vertical: "middle",
            horizontal: "center",
            wrapText: true,
          },
        },
      },
      {
        header: "Bra Size",
        width: 30,
        key: "braSize",
        style: {
          alignment: { vertical: "middle", horizontal: "left", wrapText: true },
        },
      },
      {
        header: "Bra Description",
        width: 30,
        key: "braSizeDescription",
        style: {
          alignment: { vertical: "middle", horizontal: "left", wrapText: true },
        },
      },
      {
        header: "Tumbler Type",
        width: 30,
        key: "tumblerType",
        style: {
          alignment: { vertical: "middle", horizontal: "left", wrapText: true },
        },
      },
      {
        header: "Tumbler Qty",
        width: 30,
        key: "tumblerQty",
        style: {
          alignment: {
            vertical: "middle",
            horizontal: "center",
            wrapText: true,
          },
        },
      },
      {
        header: "Previous Type",
        width: 30,
        key: "originAmount",
        style: {
          alignment: {
            vertical: "middle",
            horizontal: "center",
            wrapText: true,
          },
        },
      },
      {
        header: "Selected Type",
        width: 30,
        key: "selectedAmount",
        style: {
          alignment: {
            vertical: "middle",
            horizontal: "center",
            wrapText: true,
          },
        },
      },
      {
        header: "Change Set",
        width: 30,
        key: "changedSet",
        style: {
          alignment: {
            vertical: "middle",
            horizontal: "center",
            wrapText: true,
          },
        },
      },
      {
        header: "Male Bra",
        width: 30,
        key: "maleBra",
        style: {
          alignment: {
            vertical: "middle",
            horizontal: "center",
            wrapText: true,
          },
        },
      },
      {
        header: "Survey DateTime",
        width: 30,
        key: "surveyDateTime",
        style: {
          alignment: {
            vertical: "middle",
            horizontal: "center",
            wrapText: false,
          },
        },
      },
    ];

    worksheet.columns = column;

    const checkShirtChange = (getItem: string, item?: any): string => {
      const resolved = getItem ||
        item?.uniformSurveyExtensions?.[0]?.shirtType ||
        (item?.changedType ? '(Changed)' : '');
      if (resolved === "Red Collar" || resolved === "Driver Shirt") {
        return "Grey Collar";
      }
      return resolved;
    };

    //forech Product
    if (resultGet && resultGet.length > 0) {
      resultGet?.map((item: any, index: any) => {
        const rows = [
          {
            employeeId: item.employeeId,
            employeeId7Digit: item.employeeId7Digit,
            gender: item.gender,
            employeeName: item.employeeName,
            departmentCode: item.departmentCode,
            departmentName: item.departmentName,
            jobLevel: item.jobLevel,
            changedType: item.changedType ? "Yes" : "no",
            shirtType: checkShirtChange(item.shirtType, item),
            shirtQty: item.shirtQty,
            shirtGender: item.shirtGender,
            shirtSize: item.shirtSize,
            shirtSizeDescription: item.shirtSizeDescription,
            pantQty: item.pantQty,
            pantSize: item.pantSize,
            pantSizeDescription: item.pantSizeDescription,
            pantGender: item.pantGender,
            dressQty: item.dressQty,
            dressSize: item.dressSize,
            dressSizeDescription: item.dressSizeDescription,
            slipperQty: item.slipperQty,
            slipperSize: item.slipperSize,
            slipperSizeDescription: item.slipperSizeDescription,
            braQty: item.braQty,
            braSize: item.braSize,
            braSizeDescription: item.braSizeDescription,
            tumblerType: item.tumblerType,
            tumblerQty: item.tumblerQty,
            originAmount: item.originAmount,
            selectedAmount: item.selectedAmount,
            changedSet: item.changedSet,
            maleBra: item.maleBra,
            surveyDateTime: moment(item.surveyDateTime + "Z")
              .tz(timezoneStr)
              .format("DD-MM-YYYY HH:mm:ss"),
          },
        ];

        worksheet.addRows(rows);
        worksheet.getRow(1).font = {
          bold: true,
        };
      });
    }
    // worksheet.getCell('A1').fill = {
    //     type: 'pattern',
    //     pattern: 'solid',
    //     fgColor: { argb: 'FFFFFF00' },
    //     bgColor: { argb: 'FF28C76F' }
    // }
    worksheet.getCell("A1").alignment = {
      vertical: "middle",
      horizontal: "center",
    };
    worksheet.getCell("B1").alignment = {
      vertical: "middle",
      horizontal: "center",
    };
    worksheet.getCell("C1").alignment = {
      vertical: "middle",
      horizontal: "center",
    };
    worksheet.getCell("D1").alignment = {
      vertical: "middle",
      horizontal: "center",
    };
    worksheet.getCell("E1").alignment = {
      vertical: "middle",
      horizontal: "center",
    };
    worksheet.getCell("F1").alignment = {
      vertical: "middle",
      horizontal: "center",
    };
    worksheet.getCell("G1").alignment = {
      vertical: "middle",
      horizontal: "center",
    };
    worksheet.getCell("H1").alignment = {
      vertical: "middle",
      horizontal: "center",
    };
    worksheet.getCell("I1").alignment = {
      vertical: "middle",
      horizontal: "center",
    };
    worksheet.getCell("J1").alignment = {
      vertical: "middle",
      horizontal: "center",
    };
    worksheet.getCell("K1").alignment = {
      vertical: "middle",
      horizontal: "center",
    };
    worksheet.getCell("L1").alignment = {
      vertical: "middle",
      horizontal: "center",
    };
    worksheet.getCell("M1").alignment = {
      vertical: "middle",
      horizontal: "center",
    };
    worksheet.getCell("N1").alignment = {
      vertical: "middle",
      horizontal: "center",
    };
    worksheet.getCell("O1").alignment = {
      vertical: "middle",
      horizontal: "center",
    };
    worksheet.getCell("P1").alignment = {
      vertical: "middle",
      horizontal: "center",
    };
    worksheet.getCell("Q1").alignment = {
      vertical: "middle",
      horizontal: "center",
    };
    worksheet.getCell("R1").alignment = {
      vertical: "middle",
      horizontal: "center",
    };
    worksheet.getCell("S1").alignment = {
      vertical: "middle",
      horizontal: "center",
    };
    worksheet.getCell("T1").alignment = {
      vertical: "middle",
      horizontal: "center",
    };
    const buffer = await workbook.xlsx.writeBuffer();
    const fileType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    const fileExtension = ".xlsx";
    const today = new Date(),
      date =
        "_" +
        today.getDate() +
        "_" +
        (today.getMonth() + 1) +
        "_" +
        today.getFullYear();
    const blob = new Blob([buffer], { type: fileType });
    const fileName = "DataUniformSurvey" + date;
    FileSaver.saveAs(blob, fileName + fileExtension);
  };

  useEffect(() => {
    localStorage.setItem("Language", "en");

    if (requestLists === null) {
      setLoader(true);
      GetUniformSurveysItemList(filter, "yes").then((response: any) => {
        const getData: any = response;
        setRequestLists(getData.trans);
        if (offset === 0) {
          setPagesSelected(0);
        }
        setPagination({
          totalPage: getData.totalPages,
          currentPage: 1,
          totalCount: getData.totalCount,
        });
        setLoader(false);
      });
    }
    if (bathFile > 0 && (bathFile - 1) * limit < totalImport) {
      UploadExcelMasterFile(fileImport, limit, importOffset, bathFile)
        .then((response: any) => {
          const getData: any = response;
          if (getData.status === 200) {
            importExts = importExts.concat(
              getData.data.advanceSalaryRequestExts
            );
            importFails = importFails.concat(
              getData.data.importResult.importFails
            );
            arrimportSuccess = arrimportSuccess.concat(
              getData.data.importResult.importSuccesses
            );

            setTotalCount(getData.data.totalCount);
            setImportOffset(bathFile * limit);
            //setUploading(false)

            setFile(fileImport);
            setTotalImport(getData.data.totalCount);
            if (bathFile * limit >= parseInt(getData.data.totalCount)) {
              const impInfo: any = {
                AdvanceSalaryRequestExts: importExts,
                importResult: {
                  importFails: importFails,
                  importSuccesses: arrimportSuccess,
                },
              };
              setImportInfo(impInfo);
              setImportStatus(true);
              setUploading(false);
            }
          } else {
            setFile(fileImport);
            setUploadModalShow(false);
          }

          const current: number = bathFile * limit;
          const percent: number =
            (current / parseInt(getData.data.totalCount)) * 100;
          setProgress(percent > 100 ? 100 : percent);
          setBathFile(bathFile + 1);
        })
        .catch((error: any) => {
          setUploading(false);
          setTemplateError(error.response?.data?.message || "Upload failed");
          setBathFile(bathFile + 1);
        });
    }
  }, [filter, requestLists, bathFile, importInfo, employeeID]);
  const [isCreateForm, setIsCreateForm] = useState(false);

  return (
    <>
      <CreateUniformSueryForUsers
        showModal={formCreateModalShow}
        isCreateForm={isCreateForm}
        handleContinue={onCancelCreateSurvey}
        employeeID={employeeID}
        setEmployeeID={setEmployeeID}
        clearData={onClearData}
      />

      <div className="container-fiuld master-layout">
        <Sidemenu />
        <div className="main-container">
          <div className="col-12 mb-4">
            <Topbar />
          </div>
          <div className="container-fuild">
            <div className="row mb-2">
              <div className="col-12 my-3">
                <h1 className="page-title">Uniform Summary</h1>
              </div>
              <div className="col-12 col-sm-12 col-md-12">
                <div className="block-shadow px-2">
                  <div className="row px-4 border-bottom pb-4 filter-block">
                    <div className="col-12 col-sm-4 col-md-8">
                      {/* <div className="form-group">
                                                <label className="mb-2">MONTH</label>
                                                <select className="form-select" aria-label="Default select example" name="month" onChange={setInputValue} defaultValue={current_month}>
                                                    <option value={1} selected={(filter.month === 1) ? true : false}>January</option>
                                                    <option value={2} selected={(filter.month === 2) ? true : false}>February</option>
                                                    <option value={3} selected={(filter.month === 3) ? true : false}>March</option>
                                                    <option value={4} selected={(filter.month === 4) ? true : false}>April</option>
                                                    <option value={5} selected={(filter.month === 5) ? true : false}>May</option>
                                                    <option value={6} selected={(filter.month === 6) ? true : false}>June</option>
                                                    <option value={7} selected={(filter.month === 7) ? true : false}>July</option>
                                                    <option value={8} selected={(filter.month === 8) ? true : false}>August</option>
                                                    <option value={9} selected={(filter.month === 9) ? true : false}>September</option>
                                                    <option value={10} selected={(filter.month === 10) ? true : false}>October</option>
                                                    <option value={11} selected={(filter.month === 11) ? true : false}>November</option>
                                                    <option value={12} selected={(filter.month === 12) ? true : false}>December</option>
                                                </select>
                                            </div> */}
                    </div>
                    {/* <div className="col-12 col-sm-12 col-md-2">
                                            <div className="form-group">
                                                <label className="mb-2">YEAR</label>
                                                <select className="form-select" aria-label="Default select example" name="year" onChange={setInputValue} defaultValue={current_year}>
                                                    {
                                                        years.map((year: any) =>
                                                            <option key={`y${year}`} value={year} selected={(filter.year === year) ? true : false}>{year}</option>
                                                        )
                                                    }
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-12 col-sm-4 col-md-2">
                                            <div className="form-group">
                                                <label className="mb-2">STATUS</label>
                                                <select className="form-select" aria-label="Default select example" name="status" onChange={setInputValue} defaultValue={10}>
                                                    <option value="10" selected={(filter.status === 10) ? true : false}>All</option>
                                                    <option value="0" selected={(filter.status === 0) ? true : false}>Pending</option>
                                                    <option value="9" selected={(filter.status === 9) ? true : false}>Rejected</option>
                                                    <option value="1" selected={(filter.status === 1) ? true : false}>Approved</option>
                                                </select>
                                            </div>
                                        </div> */}
                  </div>
                  <div className="row my-3 px-4 pt-3 filter-block">
                    <div className="col-12 col-sm-4 col-md-4">
                      <div className="d-flex">
                        <label className="mt-2">Show </label>
                        <select
                          className="form-select w-auto ms-2"
                          aria-label="Default select example"
                          name="limit"
                          onChange={setInputValue}
                          defaultValue={10}
                        >
                          <option
                            value={10}
                            selected={filter.limit === 10 ? true : false}
                          >
                            10
                          </option>
                          <option
                            value={20}
                            selected={filter.limit === 20 ? true : false}
                          >
                            20
                          </option>
                          <option
                            value={30}
                            selected={filter.limit === 30 ? true : false}
                          >
                            30
                          </option>
                          <option
                            value={40}
                            selected={filter.limit === 40 ? true : false}
                          >
                            40
                          </option>
                        </select>
                      </div>
                    </div>
                    <div className="col-12 col-sm-8 col-md-8">
                      <div className="d-flex justify-content-end">
                        <div className="d-flex">
                          <label className="mt-2 me-2" data-tip="hello world">
                            Search{" "}
                          </label>
                          <InputGroup style={{ flexDirection: "column" }}>
                            <div className="d-flex">
                              <Form.Control
                                aria-label="Recipient's username"
                                aria-describedby="basic-addon2"
                                placeholder="Employee ID (7 digits) or Name"
                                name="search"
                                value={search}
                                onChange={setInputValue}
                                onKeyDown={onEnterSearch}
                              />
                              <Button
                                variant="outline-secondary btn-search-icon"
                                id="button-addon2"
                                onClick={onClickSearch}
                              >
                                <img
                                  src="../../../images/backoffice/search.png"
                                  width={20}
                                />
                              </Button>
                            </div>
                            {/^\d+$/.test(search) && search.length > 0 && search.length !== 7 && (
                              <div style={{ fontSize: "11px", color: "#dc3545", marginTop: "2px" }}>
                                Employee ID must be exactly 7 digits
                              </div>
                            )}
                          </InputGroup>
                        </div>
                        <Button
                          className="btn-submit ms-3"
                          id="create_an"
                          onClick={onCreateSurvey}
                        >
                          {" "}
                          Create
                        </Button>
                        <Button
                          className="btn-import ms-3"
                          onClick={() => handleClickImport()}
                        >
                          <img src="../../../images/backoffice/file-text.png" />{" "}
                          Import
                        </Button>
                        <Button
                          className="btn-import ms-3"
                          onClick={() => exportToExcel()}
                        >
                          <img src="../../../images/backoffice/external-link.png" />{" "}
                          Export
                        </Button>
                      </div>
                    </div>
                  </div>
                  <table className="table hr-table">
                    <thead>
                      <tr>
                        {/* <th style={{ width: "3%" }}>No</th> */}
                        <th style={{ width: "5%" }}>EmpID</th>
                        <th style={{ width: "8%" }}>EmpID 7 Digits</th>
                        {/* <th style={{ width: "3%" }}>Site</th> */}
                        <th style={{ width: "12%" }}>Name</th>
                        <th style={{ width: "8%" }}>Gender</th>
                        <th style={{ width: "20%" }}>Department</th>
                        <th style={{ width: "12%" }}>job Level</th>
                        <th className="text-center" style={{ width: "10%" }}>
                          Uniform Type
                        </th>
                        <th className="text-center" style={{ width: "10%" }}>
                          Edit Group
                        </th>
                        <th className="text-center" style={{ width: "10%" }}>
                          Survey Date
                        </th>
                        {/* <th className="text-center" style={{ "width": "10%" }}>STATUS</th> */}
                        <th className="text-center" style={{ width: "10%" }}>
                          Action
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {requestLists ? (
                        requestLists.map((item: any, key: number) => (
                          <tr key={`tr-${key}`}>
                            {/* <td>{key + 1}</td> */}

                            <td className="text-center">{item.employeeId}</td>
                            <td className="text-center">
                              {item.employeeId7Digit}
                            </td> 
                            {/* <td className="text-center">{item.site}</td> */}
                            <td className="uniform-item-text-wrap">
                              {item.employeeName}
                            </td>
                            <td className="uniform-item-text-wrap">
                              {item.gender}
                            </td>
                            <td className="uniform-item-text-wrap">
                              {item.departmentName}
                            </td>
                            <td className="uniform-item-text-wrap">
                              {item.jobLevel}
                            </td>
                            <td className="uniform-item-text-wrap text-center">
                              {checkShirtChange(item.shirtType, item)}
                            </td>
                            <td className="text-center">
                              {item.changedType ? "Yes" : "No"}
                            </td>
                            <td className="text-center">
                              {item.surveyDateTime !== null
                                ? moment(item.surveyDateTime + "Z")
                                    .tz("Asia/Bangkok")
                                    .format("DD-MM-YYYY HH:mm")
                                : ""}
                            </td>
                            {/* <td className="text-center"><Badge status="pending" text="pending" /></td> */}
                            <td className="text-center">
                              <img
                                className="a-edit"
                                src="../../../images/backoffice/view.png"
                                onClick={() => onView(item)}
                              />{" "}
                              <img
                                className="a-edit"
                                src="../../../images/backoffice/edit.png"
                                onClick={() => onEdit(item.employeeId)}
                                title="edit"
                              />{" "}
                              <img
                                className="a-edit"
                                src="../../../images/backoffice/trash.png"
                                onClick={() => onDel(item.id, item.employeeId)}
                                title="delete"
                              />
                            </td>
                            {/* <td >
                                                            <table className="table table-bordered-2 " border={1}>
                                                                {(item && item?.shirtQty > 0) ?
                                                                    <tr>
                                                                        <th scope="col" className="table-size-item">shirtSize</th> 
                                                                        <td scope="col" className="table-size-item">{item?.shirtSize}</td>
                                                                        <td scope="col" className="table-size-item">{item?.shirtQty}</td>
                                                                    </tr>
                                                                    : <></>
                                                                }
                                                                {(item && item?.pantQty > 0) ?
                                                                        <tr>
                                                                            <th className="table-size-item">pantSize</th>
                                                                            <td className="table-size-item">{item?.pantSize}</td>
                                                                            <td scope="col" className="table-size-item">{item?.pantQty}</td>
                                                                        </tr>
                                                                   : <></>
                                                                }
                                                                {(item && item?.dressQty > 0) ?
                                                                        <tr>
                                                                            <th className="table-size-item">dressSize</th>
                                                                            <td className="table-size-item">{item?.dressSize}</td>
                                                                            <td scope="col" className="table-size-item">{item?.dressQty}</td>
                                                                        </tr>
                                                                 : <></>
                                                                }
                                                                {(item && item?.braQty > 0) ?
                                                                        <tr>
                                                                            <th className="table-size-item">braSize</th>
                                                                            <td className="table-size-item">{item?.braSize}</td>
                                                                            <td scope="col" className="table-size-item">{item?.braQty}</td>
                                                                        </tr>
                                                                   : <></>
                                                                }
                                                                {(item && item?.slipperQty > 0) ?
                                                                        <tr>
                                                                            <th className="table-size-item">slipperSize</th>
                                                                            <td className="table-size-item">{item?.slipperSize}</td>
                                                                            <td scope="col" className="table-size-item">{item?.slipperQty}</td>
                                                                        </tr>
                                                                   : <></>
                                                                }
                                                                 {(item && item?.tumblerQty > 0) ?
                                                                    <tr>
                                                                        <th className="table-size-item">tumbler</th>
                                                                        <td className="table-size-item">{(item?.tumblerQty > 0)?"Accept":item?.tumblerType }</td>
                                                                        <td scope="col" className="table-size-item">{(item?.tumblerType !== 'Decline')?1:0}</td>
                                                                    </tr>
                                                                 : <></>
                                                                }

                                                                    </table>
                                                            </td> */}
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={12} className="tr_loding">
                            {loder ? (
                              <div className="loader-box">
                                <div className="spinner"></div>
                              </div>
                            ) : (
                              <></>
                            )}
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                  <ReactPaginate
                    forcePage={pagesSelected}
                    breakLabel="..."
                    nextLabel="&raquo;"
                    onPageChange={handlePageClick}
                    pageRangeDisplayed={5}
                    pageCount={pagination.totalPage}
                    previousLabel="&laquo;"
                    className="pagination justify-content-end hr-pagination"
                    pageClassName="page-item"
                    pageLinkClassName="page-link"
                    previousClassName="prevPage"
                    nextClassName="nextPage"
                    previousLinkClassName="page-link"
                    nextLinkClassName="page-link"
                    activeLinkClassName="link-active"
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="col-12">
            <Footer />
          </div>
        </div>
      </div>
      <Modal
        {...props}
        size="lg"
        backdrop="static"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={modalShow}
        onHide={helpModalClose}
      >
        <Modal.Header closeButton>
          <Modal.Title className="contained-modal-title-vcenter justify-content-center hr-modal-title">
            Request Details (EMP ID: {requestItem?.employeeId})
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-3 request-detail">
          {requestItem && requestItem !== null ? (
            <>
              <Row>
                <Col xs={2} md={1} lg={1}>
                  <img
                    src="../images/list.png"
                    alt="UniformSurvey"
                    className="m-2 mb-0 rounded"
                  />
                </Col>
                <Col xs={10} md={11} lg={11}>
                  <div className="lastest-title mt-2">
                    ข้อมูลของคุณ {requestItem.employeeName}
                  </div>
                  <div className="lastest-date">
                    {t("uniform_survey.latest_uniform_survey.date")} :{" "}
                    {moment(requestItem?.surveyDateTime + "Z")
                      .tz(timezoneStr)
                      .format("DD MMM YYYY HH:mm")}
                  </div>
                </Col>
              </Row>
              <Row className="mb-2">
                <Col>
                  <hr className="mt-2 pt-0 mb-0" />
                </Col>
              </Row>
              {requestItem?.shirtQty !== null ? (
                <Row className="align-items-center mb-2">
                  <Col xs={2} md={2} lg={2} className="m-0 p-1 text-center">
                    <img
                      src={`${
                        "../images/uniformtype/" +
                        requestItem?.shirtType.replace(" ", "-") +
                        ".jpg"
                      }`}
                      alt="UniformSurvey"
                      width={45}
                      className="m-2 rounded item-shadow border"
                    />
                  </Col>
                  <Col xs={7} md={8} lg={8}>
                    <div className="list-title font-wiegth-bold ">
                      {localStorage.getItem("Language") === "en"
                        ? props.benefit?.shirtDescriptionEn
                        : props.benefit?.shirtDescriptionTh}
                    </div>
                    <div className="list-size">
                      {/* {t('uniform_survey.choose_uniform.big_size')} */}
                      {/* {(requestItem?.shirtSize !== "Decline")?"Size: "+requestItem?.shirtSize+"("+requestItem?.shirtGender+")":<><span className='text-danger'>{t('uniform_survey.choose_uniform.no_receive')}</span></>} */}
                      {requestItem?.shirtSize === "Decline" ? (
                        <>
                          <span className="text-danger">
                            {t("uniform_survey.choose_uniform.no_receive")}
                          </span>
                        </>
                      ) : (
                        <></>
                      )}
                      {requestItem?.shirtSize === "Bigger than normal size" ? (
                        <>
                          {t("uniform_survey.choose_uniform.big_size")}(
                          {localStorage.getItem("Language") === "en"
                            ? requestItem?.shirtGender
                            : arrGender[requestItem?.shirtGender]}
                          )
                        </>
                      ) : (
                        <></>
                      )}
                      {requestItem?.shirtSize !== "Bigger than normal size" &&
                      requestItem?.shirtSize !== "Decline" ? (
                        <>
                          {t("uniform_survey.choose_uniform.size")}:{" "}
                          {requestItem?.shirtSize} (
                          {localStorage.getItem("Language") === "en"
                            ? requestItem?.shirtGender
                            : arrGender[requestItem?.shirtGender]}
                          )
                        </>
                      ) : (
                        <></>
                      )}
                    </div>
                  </Col>
                  <Col xs={3} md={2} lg={2}>
                    <div className="number mt-4">
                      {requestItem?.shirtSize !== "Decline"
                        ? requestItem?.shirtQty
                        : 0}
                    </div>
                  </Col>
                </Row>
              ) : (
                <></>
              )}

              {requestItem?.pantQty !== null ? (
                <Row className="align-items-center mb-2">
                  <Col xs={2} md={2} lg={2} className="m-0 p-1 text-center">
                    <img
                      src="../images/uniform/pants.png"
                      alt="UniformSurvey"
                      width={50}
                      className="mt-2 rounded border item-shadow"
                    />
                  </Col>
                  <Col xs={7} md={8} lg={8}>
                    <div className="list-title font-wiegth-bold">
                      {localStorage.getItem("Language") === "en"
                        ? props.benefit?.pantsDescriptionEn
                        : props.benefit?.pantsDescriptionTh}
                    </div>
                    <div className="list-size">
                      {/* {(requestItem?.pantSize !== "Decline")?"Size: "+requestItem?.pantSize+"("+requestItem?.pantGender+")":<><span className='text-danger'>{t('uniform_survey.choose_uniform.no_receive')}</span></>} */}
                      {requestItem?.pantSize === "Decline" ? (
                        <>
                          <span className="text-danger">
                            {t("uniform_survey.choose_uniform.no_receive")}
                          </span>
                        </>
                      ) : (
                        <></>
                      )}
                      {requestItem?.pantSize === "Bigger than normal size" ? (
                        <>
                          {t("uniform_survey.choose_uniform.big_size")}(
                          {localStorage.getItem("Language") === "en"
                            ? requestItem?.shirtGender
                            : arrGender[requestItem?.pantGender]}
                          ))
                        </>
                      ) : (
                        <></>
                      )}
                      {requestItem?.pantSize !== "Bigger than normal size" &&
                      requestItem?.pantSize !== "Decline" ? (
                        <>
                          {t("uniform_survey.choose_uniform.size")}:{" "}
                          {requestItem?.pantSize}{" "}
                          {t("uniform_survey.choose_uniform.UnitBar")} (
                          {localStorage.getItem("Language") === "en"
                            ? requestItem?.pantGender
                            : arrGender[requestItem?.pantGender]}
                          )
                        </>
                      ) : (
                        <></>
                      )}
                    </div>
                  </Col>
                  <Col xs={3} md={2} lg={2}>
                    <div className="number mt-4">
                      {requestItem?.pantSize !== "Decline"
                        ? requestItem?.pantQty
                        : 0}
                    </div>
                  </Col>
                </Row>
              ) : (
                <></>
              )}
              {requestItem?.dressQty !== null ? (
                <Row className="align-items-center mb-2">
                  <Col xs={2} md={2} lg={2} className="m-0 p-1 text-center">
                    <img
                      src="../images/uniform/dress.png"
                      alt="UniformSurvey"
                      width={50}
                      className="mt-2 rounded border item-shadow"
                    />
                  </Col>
                  <Col xs={7} md={8} lg={8}>
                    <div className="list-title font-wiegth-bold">
                      {localStorage.getItem("Language") === "en"
                        ? props.benefit?.dressDescriptionEn
                        : props.benefit?.dressDescriptionTh}
                    </div>
                    <div className="list-size">
                      {/* {(requestItem?.dressSize !== "Decline")?"Size: "+requestItem?.dressSize:<><span className='text-danger'>{t('uniform_survey.choose_uniform.no_receive')}</span></>} */}
                      {requestItem?.dressSize === "Decline" ? (
                        <>
                          <span className="text-danger">
                            {t("uniform_survey.choose_uniform.no_receive")}
                          </span>
                        </>
                      ) : (
                        <></>
                      )}
                      {requestItem?.dressSize === "Bigger than normal size" ? (
                        <>{t("uniform_survey.choose_uniform.big_size")}</>
                      ) : (
                        <></>
                      )}
                      {requestItem?.dressSize !== "Bigger than normal size" &&
                      requestItem?.dressSize !== "Decline" ? (
                        <>
                          {t("uniform_survey.choose_uniform.size")}:{" "}
                          {requestItem?.dressSize}{" "}
                          {t("uniform_survey.choose_uniform.UnitSlipper")}
                        </>
                      ) : (
                        <></>
                      )}
                    </div>
                  </Col>
                  <Col xs={3} md={2} lg={2}>
                    <div className="number mt-4">
                      {requestItem?.dressSize !== "Decline"
                        ? requestItem?.dressQty
                        : 0}
                    </div>
                  </Col>
                </Row>
              ) : (
                <></>
              )}

              {requestItem?.braQty !== null ? (
                <Row className="align-items-center mb-2">
                  <Col xs={2} md={2} lg={2} className="m-0 p-1 text-center">
                    <img
                      src="../images/uniform/bras.png"
                      alt="UniformSurvey"
                      width={50}
                      className="mt-2 rounded border item-shadow"
                    />
                  </Col>
                  <Col xs={7} md={8} lg={8}>
                    <div className="list-title font-wiegth-bold">
                      {localStorage.getItem("Language") === "en"
                        ? props.benefit?.braDescriptionEn
                        : props.benefit?.braDescriptionTh}
                    </div>
                    <div className="list-size">
                      {/* {requestItem?.braSize !== 'Decline' ? (
                      'Size: ' + requestItem?.braSize
                    ) : (
                      <>
                        <span className="text-danger">
                          {t('uniform_survey.choose_uniform.no_receive')}
                        </span>
                      </>
                    )} */}
                      {requestItem?.braSize === "Decline" ? (
                        <>
                          <span className="text-danger">
                            {t("uniform_survey.choose_uniform.no_receive")}
                          </span>
                        </>
                      ) : (
                        <></>
                      )}
                      {requestItem?.braSize === "Bigger than normal size" ? (
                        <>{t("uniform_survey.choose_uniform.big_size")}</>
                      ) : (
                        <></>
                      )}
                      {requestItem?.braSize !== "Bigger than normal size" &&
                      requestItem?.braSize !== "Decline" ? (
                        <>
                          {" "}
                          {t("uniform_survey.choose_uniform.size")}:{" "}
                          {requestItem?.braSize} (
                          {t("uniform_survey.choose_uniform.UnitSlipper")}/{" "}
                          {t("uniform_survey.choose_uniform.UnitBar")})
                        </>
                      ) : (
                        <></>
                      )}
                    </div>
                  </Col>
                  <Col xs={3} md={2} lg={2}>
                    <div className="number mt-4">
                      {requestItem?.braSize !== "Decline"
                        ? requestItem?.braQty
                        : 0}
                    </div>
                  </Col>
                </Row>
              ) : (
                <></>
              )}
              {requestItem?.slipperQty !== null ? (
                <Row className="align-items-center mb-2">
                  <Col xs={2} md={2} lg={2} className="m-0 p-1 text-center">
                    <img
                      src="../images/uniform/slippers.png"
                      alt="UniformSurvey"
                      width={50}
                      className="mt-2 rounded border item-shadow"
                    />
                  </Col>
                  <Col xs={7} md={8} lg={8}>
                    <div className="list-title font-wiegth-bold">
                      {localStorage.getItem("Language") === "en"
                        ? props.benefit?.slipperDescriptionEn
                        : props.benefit?.slipperDescriptionTh}
                    </div>
                    <div className="list-size">
                      {requestItem?.slipperSize === "Decline" ? (
                        <>
                          <span className="text-danger">
                            {t("uniform_survey.choose_uniform.no_receive")}
                          </span>
                        </>
                      ) : (
                        <></>
                      )}
                      {requestItem?.slipperSize ===
                      "Bigger than normal size" ? (
                        <>{t("uniform_survey.choose_uniform.big_size")}</>
                      ) : (
                        <></>
                      )}
                      {requestItem?.slipperSize !== "Bigger than normal size" &&
                      requestItem?.slipperSize !== "Decline" ? (
                        <>
                          {t("uniform_survey.choose_uniform.size")}:{" "}
                          {requestItem?.slipperSize}{" "}
                          {t("uniform_survey.choose_uniform.UnitSlipper")}
                        </>
                      ) : (
                        <></>
                      )}
                    </div>
                  </Col>
                  <Col xs={3} md={2} lg={2}>
                    <div className="number mt-4">
                      {requestItem?.slipperSize !== "Decline"
                        ? requestItem?.slipperQty
                        : 0}
                    </div>
                  </Col>
                </Row>
              ) : (
                <></>
              )}
              {requestItem?.tumblerQty !== null ? (
                <Row className="align-items-center mb-2">
                  <Col xs={2} md={2} className="m-0 p-1 text-center">
                    <img
                      src="../images/uniform/tumbler.png?a1"
                      alt="UniformSurvey"
                      width={50}
                      className="mt-2 rounded border item-shadow"
                    />
                  </Col>
                  <Col xs={7} md={8} lg={8}>
                    <div className="list-title font-wiegth-bold">
                      {localStorage.getItem("Language") === "en"
                        ? props.benefit?.tumblerDescriptionEn
                        : props.benefit?.tumblerDescriptionTh}
                    </div>
                    <div className="list-size">
                      {requestItem?.tumblerType !== "Decline" ? (
                        t("uniform_survey.choose_uniform.receive")
                      ) : (
                        <>
                          <span className="text-danger">
                            {t("uniform_survey.choose_uniform.no_receive")}
                          </span>
                        </>
                      )}

                      {requestItem?.tumblerType ===
                      "Bigger than normal size" ? (
                        <>{t("uniform_survey.choose_uniform.big_size")}</>
                      ) : (
                        <></>
                      )}
                    </div>
                  </Col>
                  <Col xs={3} md={2} lg={2}>
                    <div className="number mt-4">
                      {requestItem?.tumblerType !== "Decline"
                        ? requestItem?.tumblerQty
                        : 0}
                    </div>
                  </Col>
                </Row>
              ) : (
                <></>
              )}
            </>
          ) : (
            <></>
          )}
        </Modal.Body>
      </Modal>
      {/* <Modal
                {...props}
                size="lg"
                backdrop="static"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                show={formCreateModalShow}
                onHide={onCancelCreateSurvey}
            >
                <Modal.Header closeButton>
                    <Modal.Title className="contained-modal-title-vcenter justify-content-center hr-modal-title">
                        Create Uniforom Survey
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-3">
                    
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={() => onCreateSurvey()} className="btn-submit">
                        Save
                    </Button>
                    <Button
                        onClick={() => onCancelCreateSurvey()}
                        className="btn-cancel"
                    >
                        Cancel
                    </Button>
                </Modal.Footer>
            </Modal> */}
      <Modal
        {...props}
        size="lg"
        backdrop="static"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={uploadModalShow}
        onHide={helpModalClose}
      >
        <Modal.Header closeButton>
          <Modal.Title className="contained-modal-title-vcenter justify-content-center hr-modal-title">
            Upload Excel File
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="px-5 hr-upload-modal">
          {templateError !== "" ? (
            <Alert key="danger" variant="danger" className="message p-2">
              {templateError}
            </Alert>
          ) : (
            <>
              {importStatus &&
              importInfo &&
              importInfo?.importResult.importFails.length > 0 ? (
                <>
                  <div className="container mb-4">
                    <div className="row">
                      <div className="col-6 col-sm-6 col-md-6 ps-0">
                        <div className="block-shadow all-request h-100 import-result">
                          <div className="row align-items-center h-100">
                            <div className="col-8 ps-5">
                              <label className="text-success">
                                {
                                  importInfo?.importResult.importSuccesses
                                    .length
                                }
                              </label>
                              <p className="mb-0 text-success">
                                Import Successes
                              </p>
                            </div>
                            <div className="col-4 text-center">
                              <img
                                src="../../../images/backoffice/success.png"
                                width={50}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-6 col-sm-6 col-md-6 pe-0">
                        <div
                          className={`block-shadow all-request h-100 import-result ${
                            resultActive ? "active-result" : ""
                          }`}
                          onClick={() => setResultActive(!resultActive)}
                        >
                          <div className="row align-items-center h-100">
                            <div className="col-8 ps-5">
                              <label className="text-danger">
                                {importInfo?.importResult.importFails.length}
                              </label>
                              <p className="mb-0 text-danger">Import Fails</p>
                            </div>
                            <div className="col-4 text-center">
                              <img
                                src="../../../images/backoffice/fails.png"
                                width={50}
                              />
                            </div>
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className={`logs-info block-shadow  ${
                      resultActive ? "logs-info-show" : ""
                    }`}
                  >
                    <Table striped hover>
                      <thead>
                        <tr>
                          <th>No.</th>
                          <th>Row</th>
                          <th>Description</th>
                        </tr>
                      </thead>
                      <tbody>
                        {importInfo?.importResult.importFails.map(
                          (item: any, key: number) => (
                            <tr key={key}>
                              <td>{item.id}</td>
                              <td>{item.indexKey}</td>
                              <td>{item.description}</td>
                            </tr>
                          )
                        )}
                      </tbody>
                    </Table>
                  </div>
                </>
              ) : importStatus &&
                importInfo &&
                importInfo?.importResult.importSuccesses.length > 0 ? (
                <Alert key="success" variant="success" className="message p-2">
                  Import Successfully{" "}
                  {importInfo?.importResult.importSuccesses.length} Requests.
                </Alert>
              ) : (
                <></>
              )}
            </>
          )}

          {uploading ? (
            <div className="fileuploader text-center pt-3 min-h-253">
              {/* <div className="spinner m-auto"></div> */}
              <ProgressBar
                className="mx-5"
                now={progress || 0}
                animated
                label={`${(progress || 0).toFixed(2)}%`}
              />
              <label className="mt-2">Waiting for uploading ...</label>
            </div>
          ) : (
            <FileUploader
              multiple={false}
              handleChange={handleChange}
              name="file"
              types={fileTypes}
            />
          )}
        </Modal.Body>
      </Modal>
      {pageLoder ? (
        <div className="pageLoder">
          <div className="loader-box">
            <div className="spinner"></div>
          </div>
        </div>
      ) : (
        <></>
      )}
      <ToastContainer />
    </>
  );
};
